























import {
  createComponent,
  inject,
  onMounted,
  onUnmounted,
  computed
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyRecruitmentKey from "@/components/company-recruitment-key";
import router from '../../../router';
import FormHeader from '../../molecules/FormHeader.vue'

export default createComponent({
  setup(props, context) {
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
       const companyRecruitment = inject(CompanyRecruitmentKey);
    if (!companyRecruitment) {
      throw new Error(`${CompanyRecruitmentKey} is not provided`);
    }
    const resetTableValue = companyRecruitment.resetTableValue;
    const getListPrefecture = companyRecruitment.getListPrefecture;

    const selected = computed(() => companyRecruitment.jobSearchInfor.selected);
    const dialog = computed(() => displayui.dialogDeleteJob);
    const openDialog = computed(() => displayui.openDeleteJobDialog);
    const closeDialog = computed(() => displayui.closeDeleteJobDialog);
    const deleteJobDetail =  async() => {
      await companyRecruitment.deleteJob(selected.value)
      const paramsJobSearch = {
        prefecture: context.root.$route.query.prefecture_code,
        dateFrom: context.root.$route.query.start_work_day,
        dateTo: context.root.$route.query.end_work_day,
        state: context.root.$route.query.state
      };
      await getListPrefecture();
      if (
        !paramsJobSearch.dateFrom &&
        !paramsJobSearch.dateTo &&
        !paramsJobSearch.prefecture &&
        !paramsJobSearch.state
      ) {
        await resetTableValue();
      }
      if (
        paramsJobSearch.dateFrom ||
        paramsJobSearch.dateTo ||
        paramsJobSearch.prefecture ||
        paramsJobSearch.state ||
        paramsJobSearch.dateFrom == "" ||
        paramsJobSearch.dateTo == "" ||
        paramsJobSearch.prefecture == "" ||
        paramsJobSearch.state == ""
      ) {
        await companyRecruitment.searchJob(
          paramsJobSearch.dateFrom,
          paramsJobSearch.dateTo,
          paramsJobSearch.prefecture,
          paramsJobSearch.state
        );
      }
      displayui.closeDeleteJobDialog()
    }

    return {
      resetTableValue,
      getListPrefecture,
      dialog,
      openDialog,
      closeDialog,
      deleteJobDetail
    };
  },

  components : {
    FormHeader,
  },
})
